import React, { useEffect, useState } from "react";
import { Modal, Button, ModalTitle } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import "./ChangePassword.scss";
import { privateRequest } from "../../api/apiConfig/privateRequest";
import { publicRequest } from "../../api/apiConfig/publicRequest";
import {
  showErrorNotification,
  showSuccessNotification,
} from "../../customHooks";
import { logoutAction } from "../../redux/actions/LoginActions";
import SearchHeader from "../Reuseablecomponent/SearchHeader";
import { passwordRegex } from "../../utils/validation";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import FormikControl from "../formikcontrols";

const ChangePassword = ({ isPassOpen, closePsssModal }) => {
  const [passwordType, setPasswordType] = useState("password");
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [confPasswordType, setConfPasswordType] = useState("password");
  const [password, setPassword] = useState({
    password: "",
    newPassword: "",
    confPassword: "",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  let { data } = JSON.parse(localStorage.getItem("authUser"));

  var validationSchema = Yup.object().shape({
    password: Yup.string()
      .matches(
        passwordRegex,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      )
      .required(" Old Password is Required")
      .nullable(),
    newPassword: Yup.string()
      .matches(
        passwordRegex,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      )
      .required("New Password is Required")
      .nullable(),
    confPassword: Yup.string()
      .matches(
        passwordRegex,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      )
      .required("Confirm Password is Required")
      .nullable(),
  });
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const togglePassword1 = () => {
    if (newPasswordType === "password") {
      setNewPasswordType("text");
      return;
    }
    setNewPasswordType("password");
  };

  const togglePassword2 = () => {
    if (confPasswordType === "password") {
      setConfPasswordType("text");
      return;
    }
    setConfPasswordType("password");
  };

  const handleSubmit = async (e) => {
    try {
      await privateRequest.put(`/user/changePass/${data.id}`, { ...e });
      showSuccessNotification("Password Changed Successfully");

      dispatch(logoutAction());
      navigate("/");
    } catch (error) {
      //showErrorNotification(error.response.data.message);
    }
  };

  const handleChange = async (e) => {
    let { value, name } = e.target;

    setPassword((previous) => ({ ...previous, [name]: value }));
  };

  return (
    <Modal
      show={isPassOpen}
      onHide={closePsssModal}
      centered={true}
      animation={false}
      size="sm"
    >
      <Modal.Header className="modalpass__head">
        <span
          className="title_span"
          style={{ textAlign: "left", color: "black", fontWeight: "bold" }}
        >
          Change Password
        </span>
      </Modal.Header>
      <Modal.Body className="modalpass__body">
        <Formik
          initialValues={{
            password: "",
            newPassword: "",
            confPassword: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formik) => {
            return (
              <Form>
                <div className="flex">
                  <FormikControl
                    control="input"
                    type={passwordType}
                    name="password"
                    placeholder="Enter Old Password"
                    autoComplete="off"
                    label="Old Password"
                    className="inputold"
                  />
                  <span className="icon_showpassch" onClick={togglePassword}>
                    {passwordType === "password" ? (
                      <i className="bi bi-eye-slash"></i>
                    ) : (
                      <i className="bi bi-eye"></i>
                    )}
                  </span>
                </div>
                <div className="flex">
                  <FormikControl
                    control="input"
                    type={newPasswordType}
                    name="newPassword"
                    placeholder="Enter New Password"
                    autoComplete="off"
                    label="New Password"
                    className="inputnew"
                  />
                  <span className="icon_showpassch" onClick={togglePassword1}>
                    {newPasswordType === "password" ? (
                      <i className="bi bi-eye-slash"></i>
                    ) : (
                      <i className="bi bi-eye"></i>
                    )}
                  </span>
                </div>
                <div className="flex">
                  <FormikControl
                    control="input"
                    type={confPasswordType}
                    name="confPassword"
                    placeholder="Confirm New Password"
                    autoComplete="off"
                    label="Confirm New Password"
                    className="inputconfnew"
                  />
                  <span className="icon_showpassch" onClick={togglePassword2}>
                    {confPasswordType === "password" ? (
                      <i className="bi bi-eye-slash"></i>
                    ) : (
                      <i className="bi bi-eye"></i>
                    )}
                  </span>
                </div>

                {/* <div className="inputold">
          <input type={passwordType} autoComplete="off" name="password" onChange={handleChange}
            validation={{ required: true, pattern: passwordRegex }}
            placeholder="Enter Old Password" />
          <span className="icon_showpass" onClick={togglePassword}>
            {passwordType === "password" ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
          </span></div>

        <div className="inputnew">
          <input type={newPasswordType} autoComplete="off" name="newPassword" onChange={handleChange}
            validation={{ required: true, pattern: passwordRegex }}
            required={true}
            placeholder="Enter New Password" />
          <span className="icon_showpass" onClick={togglePassword1}>
            {newPasswordType === "password" ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
          </span>
        </div>

        <div className="inputconfnew">
          <input type={confPasswordType} autoComplete="off" name="confPassword" onChange={handleChange}
            validation={{ required: true, pattern: passwordRegex }}
            placeholder="Confirm New Password" />
          <span className="icon_showpass" onClick={togglePassword2}>
            {confPasswordType === "password" ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
          </span>
        </div> */}

                <Modal.Footer className="modalpass__footer">
                  <Button type="submit" className="modal_btn1_search">
                    Submit
                  </Button>
                  <Button className="modal_btn2_close" onClick={closePsssModal}>
                    Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            );
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default ChangePassword;
